module.exports = __webpack_public_path__ + "img/2.62f9d971.png";